import Select from '../../PrivateCompanyBlock/Select';

export const PORTALS_NAMES = Object.freeze({
  MONITOR: 'Monitor',
  BUSINESS_INTERNET: 'BusinessInternet',
});

export const STEPS = Object.freeze({
  NONE: 'None',
  SELECT_ORGANIZATION: 'SelectOrganization',
  ORGANIZATION_DASHBOARD: 'OrganizationDashboard',
});

export const SELECT_TYPES = Object.freeze({
  NONE: 'None',
  SELECT_ORGANIZATION: 'SelectOrganization',
  ORGANIZATION_DASHBOARD_SINGLE_ELEMENT: 'OrganizationDashboardSingleElement',
  ORGANIZATION_DASHBOARD_MULTI_ELEMENTS: 'OrganizationDashboardMultiElements',
});
const brandNameHe = () => window.Config?.brand_Name_HE ?? '';

export const ACTION_TITLES = Object.freeze({
  UPDATE_PAYMENT_METHOD: 'עדכון אמצעי תשלום',
  DEBT_PAYMENT: 'תשלום חוב',
  WATCH_INVOICES: 'צפייה בחשבוניות',
  get CELLCOM_ABROAD() {
    return `${brandNameHe()} חו"ל`;
  },
  SUBSCRIBER_DETAILS: 'פרטי מנוי',
  CHANGE_SIM: 'החלפת SIM/ESIM',
  DATA_USAGE: 'כמה גלשתי',
  SUSPEND_ACCOUNT: 'חסימה/פתיחה של מנוי',
  DEVICE_REPAIR: 'תאום שליחות מכשיר לתיקון',
  LOADING_EMPLOYEES_DETAILS: 'טעינת פרטי עובדים',
  CCR_REPORT: 'דוח Ccr',
  UPLOAD_EMPLOYEES_DETAILS: 'טעינת פרטי עובדים',
  BUSINESS_REPORTS: 'דוחות עסקיים',
  TRANSFER_BUSINESS_ACCOUNT: 'ניוד והפעלת קו חדש',
  RETRIEVE_QR_CODE: 'שליחת QR קוד להפעלת ESIM',
  OWNERSHIP_TRANSFER: 'העברת בעלות',
  WORK_ORDER_SYSTEM: 'מערכת פניות',
  DWH_SYSTEM: 'היסטוריית פעולות באתר',
  LOCK_UNLOCK_NP: 'פתיחה/חסימה לניוד',
  ACTIVATE_NIUD: 'הפעלת ניוד',
  CHECK_NIUD_STATUS: 'בדיקת סטטוס ניוד'
});
